// extracted by mini-css-extract-plugin
export default {"content":"PageContent__content___2aVq_"};